module.exports = __webpack_public_path__ + "media/images/favicon/safari-pinned-tab-027018e0004555835d620956ec7cce0d.svg";